import { fiHtmlToText } from '@fi-shared/utils';

export function getProfileIconColor(name: string) {
    return stringToHslColor(name, 20, 70);
}

// https://medium.com/@pppped/compute-an-arbitrary-color-for-user-avatar-starting-from-his-username-with-javascript-cd0675943b66
function stringToHslColor(str: string, s: number, l: number) {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }

    const h = hash % 360;
    return 'hsl(' + h + ', ' + s + '%, ' + l + '%)';
}

export function getUserProfileAbbr(userFullName: string): string {
    return fiHtmlToText(userFullName)
        .split(' ')
        .filter((char) => char)
        .map((part) => part.slice(0, 1).toUpperCase())
        .slice(0, 2)
        .join('');
}
